import { TypedListener } from "@/store";
import { createSlice, createAction, createListenerMiddleware } from "@reduxjs/toolkit";

const PINCODE_STORAGE_KEY = 'eb-pincode'

export const setPincode = createAction('/pincode/SET_PINCODE', (pincode: string) => {
    return {
        payload: pincode
    }
});
export const authorise = createAction('/pincode/AUTHORISE');
export const unauthorise = createAction('/pincode/UNAUTHORISE');

// Middlewares
export const listener = createListenerMiddleware();
const startListening = listener.startListening as TypedListener;

const pincodeSlice = createSlice({
    name: 'pincode',
    initialState: {
        entity: {
            authorised: false,
            code: ''
        }
    },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(authorise, (state) => {
            state.entity.authorised = true;
        });
        builder.addCase(unauthorise, (state) => {
            state.entity.authorised = false;
        });
        builder.addCase(setPincode, (state, { payload }) => {
            state.entity.code = payload;
        });
    }
});

startListening({
    predicate: (action) => action.type === 'FETCH_COMPANY_SUCCESS',
    effect: ({ payload }, state) => {
        const alreadyAuthorised = sessionStorage.getItem(PINCODE_STORAGE_KEY);
        const disablePinCodeRestriction = state.getState().configuration.data?.disablePinCodeRestriction;
        if(payload && payload.BookingSettings && !alreadyAuthorised && !disablePinCodeRestriction) {
            state.dispatch(setPincode(payload.BookingSettings.BookingPinCodeRestriction));
        }
    }
});

startListening({
    matcher: authorise.match,
    effect: () => {
        sessionStorage.setItem(PINCODE_STORAGE_KEY, "true");
    }
});



export default pincodeSlice;